module.exports = __webpack_public_path__ + "static/media/nxia.7b9726df.png";